module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAdCAYAAAC5UQwxAAAA8klEQVR4AWJwL/ChKwa0VwcnE8JQEIDtIEV4tYS/ABuwDatIAzkLlpUSbCKH/FkY2TDoOjx4Nx/MJWT2g7ds9vKw1jq1ZGS6Kes9AUz1O0kHuaeDW1fcBEzufS6Flj8k3BTpHkXvhQH7Pmf+UZwrjaGXByouuBS7s4izhRVLrwd5DRGhdWGMPQbLuZ4+WEthxdIbbsqp+6LTA6b3APrPCxrnaFmRwxs8+scaqBNIGMDoAgIbtd+sAGI1Y0u0YzqY6cPWB2w5MQtYkMCoillXmi/QYMUYFFE7poKE2jEJJHRkzA3EFH62/EFh3r+nnVblOfs/SsOfxZeIiz8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/sign-btn-icon.png
// module id = OYEK
// module chunks = 216